export const formatRatio = (num: number, lang: string, noOfDigits?: number) => {
  if (num == null) return '';
  const formatted = new Intl.NumberFormat(`${lang}-CA`, {
    style: 'decimal',
    minimumFractionDigits: noOfDigits ?? 2,
    maximumFractionDigits: noOfDigits ?? 2
  }).format(num);
  return `${formatted}%`;
};
